import React from "react";

import {
  Error,
  Header,
  Loading,
  GridView,
  TypeOfMeetingCard,
} from "components";

import { strings } from "assets/constants";
import { sn } from "utils";

import { useGetTypeOfMeetings } from "clients/apis";

const TypeOfMeeting = () => {
  const { isLoading, data, isError, error, refetch, isRefetching } =
    useGetTypeOfMeetings();

  const _renderContent = () => {
    if (isLoading) {
      return <Loading style={{ marginTop: 20 }} />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    return (
      <GridView
        gridHeight={90}
        numberOfCol={sn(3, 4, 6, 7)}
        data={[...data?.data?.data?.items, null] as Array<TypeOfMeetingT>}
        renderItem={(item) => <TypeOfMeetingCard typeOfMeeting={item} />}
      />
    );
  };

  return (
    <>
      <Header title={strings.familiarity_way} />
      {_renderContent()}
    </>
  );
};

export default TypeOfMeeting;
